import * as React from 'react';
import { DeliveryContext } from '../context/DeliveryContext';

export const useDeliveryContext = () => {
  return React.useContext(DeliveryContext);
};
